
// Flag to ensure slider is initialized only once
let isSliderInitialized = false;

document.addEventListener('DOMContentLoaded', function() {
  // Function to reorder language list
  function reorderLanguages() {
    const selectedCountry = document.querySelector('input[name="country_code"]').value;
    const languageList = document.getElementById('AnnouncementLanguageList');
    const languages = Array.from(languageList.children);

    if (selectedCountry === 'DE') {
      // Find the Deutsch language item
      const germanLang = languages.find(lang => lang.querySelector('a').getAttribute('data-value') === 'de');
      if (germanLang) {
        // Remove it from its current position
        languageList.removeChild(germanLang);
        // Insert it at the beginning
        languageList.insertBefore(germanLang, languageList.firstChild);
      }
    }
  }

  // Initial reorder on page load
  reorderLanguages();

  // Listen for changes in the country selection
  const countryLinks = document.querySelectorAll('#AnnouncementCountryList a');
  countryLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const selectedCountryCode = this.getAttribute('data-value');
      // Update the hidden input value
      document.querySelector('input[name="country_code"]').value = selectedCountryCode;
      // Reorder languages based on the new country selection
      reorderLanguages();
      // Optionally, submit the form or perform other actions
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hostname.includes("swijin.ch")) {
    function replaceTextContent(element, oldText, newText) {
      var escapedOldText = oldText.replace('.', '\\.');
      var regex = new RegExp(escapedOldText, 'gi'); // Case-insensitive matching

      if (element.nodeType === Node.TEXT_NODE) {
        element.textContent = element.textContent.replace(regex, function(match, offset, string) {
          // Check if the match is part of an email address
          var isEmail = false;

          // Check for '@' before the match
          var beforeMatch = string.slice(0, offset);
          var lastSpaceBefore = beforeMatch.lastIndexOf(' ');
          var lastAtBefore = beforeMatch.lastIndexOf('@');
          if (lastAtBefore > lastSpaceBefore) {
            isEmail = true;
          }

          // Check for '@' after the match
          var afterMatch = string.slice(offset + match.length);
          var nextSpaceAfter = afterMatch.indexOf(' ');
          var nextAtAfter = afterMatch.indexOf('@');
          if (nextAtAfter !== -1 && (nextAtAfter < nextSpaceAfter || nextSpaceAfter === -1)) {
            isEmail = true;
          }

          if (isEmail) {
            return match; // Don't replace if part of an email
          } else {
            return newText; // Replace with proper capitalization
          }
        });
      } else {
        element.childNodes.forEach(function (child) {
          replaceTextContent(child, oldText, newText);
        });
      }
    }

    replaceTextContent(document.body, "swijin.com", "Swijin.ch");
  }
});





// Function to initialize the slider functionality
const initializeSlider = () => {
  if (isSliderInitialized) {
    //console.log('Slider already initialized. Skipping initialization.');
    return; // Exit if the slider is already initialized
  }

  const slideList = document.querySelectorAll('.product__media-list .product__media-item');
  const thumbnailList = document.querySelectorAll('.thumbnail-list__item button');
  const totalSlides = slideList.length;
  let currentSlideIndex = 0;

  const prevButton = document.querySelector('.slider-button--prev');
  const nextButton = document.querySelector('.slider-button--next');

  if (!slideList.length || !prevButton || !nextButton) {
    //console.log('Slider elements not found. Initialization aborted.');
    return;
  }

  const updateActiveSlide = () => {
    slideList.forEach(slide => slide.classList.remove('is-active'));

    currentSlideIndex = Math.max(0, Math.min(currentSlideIndex, totalSlides - 1));

    //console.log('Current Slide:', currentSlideIndex + 1, '/', totalSlides);
    
    slideList[currentSlideIndex].classList.add('is-active');
    
    if (window.innerWidth < 750) {
      prevButton.style.display = 'block';
      nextButton.style.display = 'block';
    } else {
      prevButton.style.display = currentSlideIndex === 0 ? 'none' : 'block';
      nextButton.style.display = currentSlideIndex === totalSlides - 1 ? 'none' : 'block';
    }
  };

  const showNextSlide = () => {
    if (currentSlideIndex < totalSlides - 1) {
      currentSlideIndex++;
      updateActiveSlide();
    }
  };

  const showPreviousSlide = () => {
    if (currentSlideIndex > 0) {
      currentSlideIndex--;
      updateActiveSlide();
    }
  };

  nextButton.addEventListener('click', showNextSlide);
  prevButton.addEventListener('click', showPreviousSlide);

  // Add click event listeners to thumbnails
  thumbnailList.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      currentSlideIndex = index;
      //console.log('Thumbnail clicked. Setting currentSlideIndex to:', index + 1);
      updateActiveSlide();
    });
  });

  updateActiveSlide();

  // Mark slider as initialized
  isSliderInitialized = true;
};

// Function to observe DOM changes and prevent re-initialization from conflicts
const observeDOMChanges = () => {
  const observer = new MutationObserver(mutations => {
    let shouldInitialize = false;

    mutations.forEach(mutation => {
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        // Check if the change affects the slider directly and it's not initialized
        if (mutation.target.closest('.product__media-list') && !isSliderInitialized) {
          shouldInitialize = true;
        }
      }
    });

    if (shouldInitialize) {
      initializeSlider();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial call to set up the slider when the page loads
  initializeSlider();
};

// Start observing when the DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
  initializeSlider(); // Initialize slider on page load
  observeDOMChanges(); // Start observing DOM changes
});


document.addEventListener('DOMContentLoaded', function() {
    // List of target page paths where you want to hide the div
    var targetPages = [
        '/products/schnuggi-high-impact',
        '/products/the-freeli-sports-bra-1',
        '/products/the-barli-there-t-shirt',
        '/products/the-schnuggi-ultra'
    ];

    // Check if the current page path is one of the target pages
    var isTargetPage = targetPages.some(page => window.location.pathname.includes(page));

    // Select the div you want to hide
    var targetDiv = document.querySelector('[data-tab="ks-chart-tab-container"]');

    // Select the button that will show the div
    var showDivButton = document.querySelector('.btn.ks-calculator-modal-button.sizing-calculator-modal-button');

    // Hide the div only on specific pages
    if (isTargetPage && targetDiv) {
        targetDiv.style.display = 'none'; // Hide the div initially

        // Add an event listener to the button to show the div when clicked
        showDivButton.addEventListener('click', function() {
            targetDiv.style.display = 'block'; // Show the div on button click
        });
    }
});



function changeButtonText(buttonId, newText) {
  // Select the button by its ID
  var button = document.getElementById(buttonId);

  // Check if the button exists on the page
  if (button) {
    // Select the <span> element inside the button to change its text
    var buttonText = button.querySelector("span");

    // Check if the <span> element exists
    if (buttonText) {
      //console.log("Button found, changing text..."); // Debugging log
      buttonText.textContent = newText; // Change the text
    } else {
      //console.log("Button found, but <span> element is missing."); // Debugging log
    }
  } else {
    //console.log("Button not found for ID: " + buttonId); // Debugging log
  }
}

// Change text for both buttons
changeButtonText("ProductSubmitButton-template--17302602219671__main", "COMING SOON");
changeButtonText("ProductSubmitButton-template--17302602121367__main", "COMING SOON");

 
function replaceCO2InParagraphs() {
    // Get all <p> elements in the document
    var paragraphs = document.querySelectorAll('p');

    // Loop through each <p> element
    paragraphs.forEach(function(p) {
        // Replace "CO2" with "CO₂" in the text content of the <p> element
        p.innerHTML = p.innerHTML.replace(/CO2/g, "CO<sub>2</sub>");
    });
}

// Call the function to replace "CO2" inside <p> tags
replaceCO2InParagraphs();

let attemptCount = 0; // Initialize the attempt counter
const maxAttemptsk = 15; // Set the maximum number of attempts

function checkForElement() {
    // Check if either of the elements with the given IDs exist on the page
    var element1 = document.getElementById('ProductInfo-template--17302601859223__main');
    var element2 = document.getElementById('ProductInfo-template--17302602186903__main');

    // Proceed if either element1 or element2 is found
    if (element1 || element2) {
        var targetElement = document.querySelector('.ks-modal-tab[data-tab="ks-chart-tab-container"]');
        
        if (targetElement) {
            //console.log("Found it");  // Log message once the element is found
            targetElement.style.color = 'red';  
            targetElement.style.position = 'absolute'; 
            targetElement.style.display = 'none';  // Hide the element by setting display to none
            clearInterval(checkInterval);  // Stop checking once the element is found
        }
    } else {
        //console.log(`Attempt ${attemptCount + 1}: Neither element found. Retrying...`);
        attemptCount++; // Increment the attempt counter

        // Stop checking after 15 attempts
        if (attemptCount >= maxAttemptsk) {
            //console.log("Max attempts reached. Stopping further checks.");
            clearInterval(checkInterval);
        }
    }
}

// Set an interval to keep checking for the element every 500 milliseconds
var checkInterval = setInterval(checkForElement, 500);





document.addEventListener("DOMContentLoaded", function() {
  // Create a function to filter and reorder the currency list items
  function filterAndReorderCurrencyList(listId) {
    // Select the currency dropdown list by being more specific to avoid other language dropdown lists
    const currencyListWrapper = document.querySelector(`.disclosure__list-wrapper ul[id="${listId}"]`);

    if (!currencyListWrapper) {
      return; // If no list found, exit
    }

    // Select all currency items within the list
    const currencyItems = currencyListWrapper.querySelectorAll('.disclosure__item');

    // Define an array of allowed country values in the desired order
    const allowedCountries = ["CH", "DE", "US", "GB"];

    // Create an array to hold the filtered and ordered items
    const orderedListItems = [];

    // Loop through the list of currency items
    currencyItems.forEach(function(item) {
      // Get the data-value attribute of the current item
      const countryValue = item.querySelector('a').getAttribute('data-value');

      // If the countryValue is allowed, store the item in the correct order
      if (allowedCountries.includes(countryValue)) {
        const orderIndex = allowedCountries.indexOf(countryValue);
        orderedListItems[orderIndex] = item;
      } else {
        // Hide the item if it's not allowed
        item.style.display = 'none';
      }
    });

    // Clear the existing list items from the DOM
    currencyListWrapper.innerHTML = '';

    // Append the filtered and ordered items to the currency list wrapper
    orderedListItems.forEach(function(listItem) {
      if (listItem) {
        currencyListWrapper.appendChild(listItem);
      }
    });
  }

  // Call the function for both AnnouncementCountryList and HeaderCountryMobileList
  filterAndReorderCurrencyList('AnnouncementCountryList');
  filterAndReorderCurrencyList('HeaderCountryMobileList');
});





document.addEventListener("DOMContentLoaded", function() {
  // Get the current hostname
  var currentHost = window.location.hostname;

  // Get the language attribute from the HTML tag
  var htmlLang = document.documentElement.lang;

  // Check if the domain is '.ch'
  if (currentHost.includes('.ch')) {
    // Select all footer links
    var footerLinks = document.querySelectorAll('footer a');

    // Loop through each footer link
    footerLinks.forEach(function(link) {
      // Replace all occurrences of swijin.com with swijin.ch in href attributes
      if (link.href.includes('swijin.com')) {
        link.href = link.href.replace(/swijin\.com/g, 'swijin.ch');
      }

      // If lang is "de", remove "/de/" from href attributes if present
      if (htmlLang === 'de' && link.href.includes('/de/')) {
        link.href = link.href.replace('/de/', '/');
      }

      // If lang is "fr", remove "/fr/" from href attributes if present
      if (htmlLang === 'fr' && link.href.includes('/fr/')) {
        link.href = link.href.replace('/fr/', '/');
      }

      // If lang is "en", add "/en/" before "/pages/" in href attributes if not already present
      if (htmlLang === 'en' && link.href.includes('/pages/') && !link.href.includes('/en/pages/')) {
        link.href = link.href.replace('/pages/', '/en/pages/');
      }

      // If lang is "fr", add "/fr/" before "/pages/" in href attributes if not already present
      if (htmlLang === 'fr' && link.href.includes('/pages/') && !link.href.includes('/fr/pages/')) {
        link.href = link.href.replace('/pages/', '/fr/pages/');
      }
    });
  }
});


 
  document.addEventListener("DOMContentLoaded", function() {
    // Get the language attribute from the HTML tag
    var htmlLang = document.documentElement.lang;

    // Select all the h1 elements within the slider
    var sliderHeadings = document.querySelectorAll('.slider-con h1');

    // Loop through each heading and change the text based on the language
    sliderHeadings.forEach(function(heading) {
      if (heading.textContent.trim() === 'Meet the first intelligent sports bra.') {
        if (htmlLang === 'de') {
          heading.textContent = 'Entdecke den ersten intelligenten Sport-BH';
        } else if (htmlLang === 'fr') {
          heading.textContent = 'Découvre la première brassière de sport intelligente.';
        }
      }
    });
  });
 

document.addEventListener("DOMContentLoaded", function() {
  // Define translations for English, German, and French
  const translations = {
    en: "Stay in the loop! Drop your email for restock updates!",
    de: "Bleiben Sie auf dem Laufenden! Geben Sie Ihre E-Mail-Adresse für Benachrichtigungen über Wiederverfügbarkeit ein!",
    fr: "Restez informé ! Laissez votre e-mail pour recevoir des mises à jour sur les réapprovisionnements !"
  };

  // Get the current language from the <html> lang attribute
  const lang = document.documentElement.getAttribute('lang') || 'en';

  // Find the existing span by its text content and update it
  const spanElements = document.querySelectorAll('span');
  spanElements.forEach(function(span) {
    // Check if the text matches the English version
    if (span.textContent.includes(translations['en'])) {
      // Update the text based on the current language
      span.textContent = translations[lang] || translations['en'];
    }
  });
});

function translateRestockMessage() {
  // Define translations for English, German, and French
  const translations = {
    en: "Stay in the loop! Drop your email for restock updates!",
    de: "Bleiben Sie auf dem Laufenden! Geben Sie Ihre E-Mail-Adresse für Benachrichtigungen über Wiederverfügbarkeit ein!",
    fr: "Restez informé ! Laissez votre e-mail pour recevoir des mises à jour sur les réapprovisionnements !"
  };

  // Get the current language from the <html> lang attribute
  const lang = document.documentElement.getAttribute('lang') || 'en';

  // Find the existing span by its text content and update it
  const spanElements = document.querySelectorAll('span');
  spanElements.forEach(function(span) {
    // Check if the text matches the English version
    if (span.textContent.includes(translations['en'])) {
      // Update the text based on the current language
      span.textContent = translations[lang] || translations['en'];
    }
  });
}

// Example usage of the function
document.addEventListener("DOMContentLoaded", function() {
  translateRestockMessage();
});


document.addEventListener("DOMContentLoaded", function () {
  function applyIntlShippingStyling() {
    const intlShippingSpan = document.querySelector('.intl-shipping');

    if (intlShippingSpan) {
      const childNodes = Array.from(intlShippingSpan.childNodes);

      childNodes.forEach(node => {
        // Check if the node is a text node and not already wrapped in a span
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {

          // Ensure that the text node is not already wrapped in a span
          if (node.parentNode === intlShippingSpan) {
            // Create a new span to wrap around the text node
            const newSpan = document.createElement('span');
            newSpan.textContent = node.textContent.trim();

            // Apply styles
            newSpan.style.transform = 'translateY(2px)';
            newSpan.style.display = 'inline-block';

            // Replace the text node with the new span
            intlShippingSpan.replaceChild(newSpan, node);
          }
        }
      });
    }
  }

  // Initially apply the styling
  applyIntlShippingStyling();

  // Listen for Shopify-specific events that might cause a re-render
  document.addEventListener('shopify:section:load', applyIntlShippingStyling);
  document.addEventListener('shopify:section:unload', applyIntlShippingStyling);
  document.addEventListener('shopify:section:select', applyIntlShippingStyling);
  document.addEventListener('shopify:section:deselect', applyIntlShippingStyling);
  document.addEventListener('shopify:section:reorder', applyIntlShippingStyling);
  document.addEventListener('shopify:section:filter', applyIntlShippingStyling);
  document.addEventListener('shopify:block:select', applyIntlShippingStyling);
  document.addEventListener('shopify:block:deselect', applyIntlShippingStyling);

  // Reapply styling when variant changes
  const variantRadioContainer = document.querySelector('.variant-radios');
  if (variantRadioContainer) {
    variantRadioContainer.addEventListener('change', function () {
      applyIntlShippingStyling();
    });
  }

  // Use MutationObserver to watch for DOM changes to the variant radios
  const observer = new MutationObserver(function (mutationsList, observer) {
    // Reapply styling when the DOM changes
    applyIntlShippingStyling();
  });

  // Start observing the entire body or a specific container for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true // Listen to all changes within the subtree
  });
});








document.addEventListener("DOMContentLoaded", function() {
  // Get the current language from the <html> tag or use 'en' as default
  const lang = document.documentElement.lang || 'en';

  // Select all the product buttons (assuming they're the first three product buttons)
  const productButtons = document.querySelectorAll('.featured-product a');

  // Loop through the product buttons and add the corresponding classes
  productButtons.forEach(function(button, index) {
    // Determine the class to add based on the language and index
    const classToAdd = `${lang}-${index + 1}`;
    
    // Add the class to the button
    button.classList.add(classToAdd);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select the div with the class 'element-label'
  const labelDiv = document.querySelector('.element-label');
  
  // Check if the div exists and if it is empty (no text content or child elements)
  if (labelDiv && labelDiv.textContent.trim() === "") {
    // Hide the div if it's empty
    labelDiv.style.display = 'none';
    //console.log("found")
  }
});



if (window.location.href === "https://swijin.com/collections") {
  window.location.href = window.location.href + "/all-collections";
}

// Replace Denomiation 

document.addEventListener("DOMContentLoaded", function () {
  // Check if HTML language is set to 'en'
  const htmlLang = document.documentElement.lang;

  if (htmlLang === "en") {
    // Check if the variant radios element exists
    const variantRadios = document.getElementById("variant-radios-template--17302601760919__main");

    if (variantRadios) {
      // Find the <legend> element inside the fieldset
      const legendElement = variantRadios.querySelector("legend.form__label");

      if (legendElement) {
        // Replace the text
        legendElement.textContent = "Select your card value";
      }
    }
  }
});


// Replace Currency
// Declare a global variable to store the currency symbol
window.currentCurrencySymbol = '';

// Function to extract the currency symbol from the price span
function extractAndStoreCurrencySymbol() {
  // Select the span with the specified classes
  const priceSpan = document.querySelector('.price-item.price-item--regular');
  
  if (priceSpan) {
    // Get the text content, e.g., "$140.00"
    const priceText = priceSpan.textContent.trim();
    
    // Extract the first non-digit character(s) as the currency symbol
    // This handles symbols like $, €, £, CHF, etc.
    const symbolMatch = priceText.match(/^[^\d.,\s]+/);
    
    if (symbolMatch) {
      window.currentCurrencySymbol = symbolMatch[0];
      //console.log('Current Currency Symbol:', window.currentCurrencySymbol);
    } else {
      console.warn('No currency symbol found in the price text.');
    }
  } else {
    console.warn('Price span not found.');
  }
}

// Run the function after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', extractAndStoreCurrencySymbol);



document.addEventListener('DOMContentLoaded', () => {
  // Define the new currency symbol from a global variable
  const newCurrency = window.currentCurrencySymbol; // Ensure this variable is defined elsewhere

  // Select the <variant-radios> element by its ID
  const variantRadios = document.getElementById('variant-radios-template--24354826060152__main');

  if (variantRadios) {
    // Select all radio inputs within the <variant-radios> element
    const inputs = variantRadios.querySelectorAll('input[type="radio"]');

    inputs.forEach(input => {
      // Replace the currency symbol in the value attribute if it starts with '€'
      if (input.value.startsWith('€')) {
        input.value = newCurrency + input.value.substring(1);
      }

      // Find the corresponding label using the 'for' attribute
      const label = variantRadios.querySelector(`label[for="${input.id}"]`);
      if (label) {
        // Replace the first occurrence of '€' with the new currency symbol in the label's inner HTML
        label.innerHTML = label.innerHTML.replace('€', newCurrency);

        // **New Addition: Apply margin if the currency is CHF**
        if (newCurrency === 'CHF') {
          label.style.margin = '0 5px';
        } else {
          // Optional: Reset margin if it's not CHF
          label.style.margin = '';
        }
      }
    });
  } else {
    //console.warn('Variant radios element not found!');
  }
});

// Cart Pop Text
window.currentCurrencySymbol = window.currentCurrencySymbol || "€";

// Text translations based on the <html> lang attribute
var language = document.documentElement.lang || "en"; // default to English if no lang set
var dtTextMap = {
  "en": "Card Value: ",
  "de": "Kartenwert: ",
  "fr": "Valeur de la carte:"
};

function updateProductOptionInCart() {
  const productOption = document.querySelector(".product-option dt");
  const ddElements = document.querySelectorAll(".product-option dd");
  
  if (!productOption) {
    //console.log("No dt element found. Check your selectors or timing.");
    return;
  }

  // Always replace dt text based on current language
  const translatedText = dtTextMap[language] || dtTextMap["en"];
  productOption.textContent = translatedText;

  // Update dd elements to start with the current currency symbol
  ddElements.forEach((dd) => {
    let currentText = dd.textContent.trim();
    if (!currentText.startsWith(window.currentCurrencySymbol)) {
      currentText = window.currentCurrencySymbol + currentText.replace(/^[^0-9]+/, "");
      dd.textContent = currentText;
    }
  });
}

// Add event listener to your button:
document.addEventListener("DOMContentLoaded", function() {
  const button = document.getElementById("ProductSubmitButton-template--24354826060152__main");
  if (button) {
    button.addEventListener("click", function() {
      // Wait for the cart popup to appear
      setTimeout(updateProductOptionInCart, 1000); 
      // Adjust the delay as needed depending on your theme’s load time.
    });
  } else {
    //console.log("Button not found. Check your button ID.");
  }
});



// Hide on cart page
document.addEventListener("DOMContentLoaded", function() {
  // Select all cart item details
  const cartItemDetailsElements = document.querySelectorAll(".cart-item__details");

  cartItemDetailsElements.forEach((itemDetails) => {
    const itemNameLink = itemDetails.querySelector(".cart-item__name");
    if (itemNameLink && itemNameLink.href.includes("swijin-gift-card")) {
      // Get all product-option elements within this cart item
      const productOptions = itemDetails.querySelectorAll(".product-option");
      if (productOptions.length > 1) {
        // Hide the second product-option
        productOptions[1].style.display = "none";
      }
    }
  });
});


// Sold Out Tracker
//  document.addEventListener('DOMContentLoaded', function() {
//    const lang = document.documentElement.lang; // Define lang
// const kInput = document.getElementById('k-input-front');

// // Remove existing klaviyo-form classes
// kInput.classList.remove(
//     "klaviyo-form-UbyLHD",
//     "klaviyo-form-RfpZn5",
//     "klaviyo-form-TzTELJ"
// );

// if (lang === 'en') {
//     kInput.classList.add("klaviyo-form-UbyLHD");
// } else if (lang === 'de') {
//     kInput.classList.add("klaviyo-form-RfpZn5");
// } else if (lang === 'fr') {
//     kInput.classList.add("klaviyo-form-TzTELJ");
// }
//     // Unique ID of the variant-radios container
//     const variantRadiosContainerId = 'variant-radios-template--17410794356887__main';
//     const variantRadiosContainer = document.getElementById(variantRadiosContainerId);

//     if (!variantRadiosContainer) {
//       console.error(`Container with ID "${variantRadiosContainerId}" not found.`);
//       return;
//     }

//     // Parse the JSON data containing variant information
//     const jsonScript = variantRadiosContainer.querySelector('script[type="application/json"]');
//     let variants = [];

//     if (jsonScript) {
//       try {
//         variants = JSON.parse(jsonScript.textContent);
//       } catch (e) {
//         console.error('Error parsing variant JSON:', e);
//       }
//     } else {
//       console.error('Variant JSON script not found.');
//     }

//     // Function to check if a variant is available based on its value
//     function isVariantAvailable(selectedValue) {
//       const variant = variants.find(v => v.title === selectedValue);
//       return variant ? variant.available : true; // Default to true if variant not found
//     }

//     // Function to toggle the visibility of the div
//     function toggleKInputFront(selectedValue) {
//       const kInputFront = document.getElementById('k-input-front');
//       if (!kInputFront) {
//         console.error('Div with ID "k-input-front" not found.');
//         return;
//       }

//       if (!isVariantAvailable(selectedValue)) {
//         kInputFront.style.display = 'block';
//       } else {
//         kInputFront.style.display = 'none';
//       }
//     }

//     // Function to handle radio button changes
//     function handleRadioChange(event) {
//       const selectedValue = event.target.value;
//       toggleKInputFront(selectedValue);
//     }

//     // Initial check on page load
//     (function initialCheck() {
//       // Select all radio buttons within the container
//       const radios = variantRadiosContainer.querySelectorAll('input[type="radio"]');
//       let selectedRadio = null;

//       radios.forEach(radio => {
//         if (radio.checked) {
//           selectedRadio = radio;
//         }
//       });

//       if (selectedRadio) {
//         toggleKInputFront(selectedRadio.value);
//       } else {
//         // If no radio is selected, hide the div
//         const kInputFront = document.getElementById('k-input-front');
//         if (kInputFront) {
//           kInputFront.style.display = 'none';
//         }
//       }
//     })();

//     // Add event listeners to all radio buttons within the container
//     const radios = variantRadiosContainer.querySelectorAll('input[type="radio"]');
//     radios.forEach(radio => {
//       radio.addEventListener('change', handleRadioChange);
//     });
//   });

document.addEventListener('DOMContentLoaded', function() {
    const lang = document.documentElement.lang; // Define lang
    const kInput = document.getElementById('k-input-front');

  
    // If kInput is not found, return early
    if (!kInput) {
         
        return;
    }
    
    // Remove existing klaviyo-form classes
    if (kInput) {
    kInput.classList.remove(
        "klaviyo-form-VxgQgb",
        "klaviyo-form-SRe955",
        "klaviyo-form-RnQLTg"
    );
} else {
    //console.warn('Element with ID "k-input-front" not found.');
}
    
    if (lang === 'en') {
        kInput.classList.add("klaviyo-form-VxgQgb");
    } else if (lang === 'de') {
        kInput.classList.add("klaviyo-form-SRe955");
    } else if (lang === 'fr') {
        kInput.classList.add("klaviyo-form-RnQLTg");
    }

    // Replace specific ID with a dynamic selector
    const variantRadiosContainers = document.querySelectorAll('[id^="variant-radios-template--"][id$="__main"]');

    variantRadiosContainers.forEach(variantRadiosContainer => {
        if (!variantRadiosContainer) {
            console.error(`Container not found.`);
            return;
        }

        // Parse the JSON data containing variant information
        const jsonScript = variantRadiosContainer.querySelector('script[type="application/json"]');
        let variants = [];

        if (jsonScript) {
            try {
                variants = JSON.parse(jsonScript.textContent);
            } catch (e) {
                console.error('Error parsing variant JSON:', e);
            }
        } else {
            console.error('Variant JSON script not found.');
        }

        // Function to check if a variant is available based on its value
        function isVariantAvailable(selectedValue) {
            const variant = variants.find(v => v.title === selectedValue);
            return variant ? variant.available : true; // Default to true if variant not found
        }

        // Function to toggle the visibility of the div
        function toggleKInputFront(selectedValue) {
            const kInputFront = document.getElementById('k-input-front');
            if (!kInputFront) {
                console.error('Div with ID "k-input-front" not found.');
                return;
            }

            if (!isVariantAvailable(selectedValue)) {
                kInputFront.style.display = 'block';
            } else {
                kInputFront.style.display = 'none';
            }
        }

        // Function to handle radio button changes
        function handleRadioChange(event) {
            const selectedValue = event.target.value;
            toggleKInputFront(selectedValue);
        }

        // Initial check on page load
        (function initialCheck() {
            // Select all radio buttons within the container
            const radios = variantRadiosContainer.querySelectorAll('input[type="radio"]');
            let selectedRadio = null;

            radios.forEach(radio => {
                if (radio.checked) {
                    selectedRadio = radio;
                }
            });

            if (selectedRadio) {
                toggleKInputFront(selectedRadio.value);
            } else {
                // If no radio is selected, hide the div
                const kInputFront = document.getElementById('k-input-front');
                if (kInputFront) {
                    kInputFront.style.display = 'none';
                }
            }
        })();

        // Add event listeners to all radio buttons within the container
        const radios = variantRadiosContainer.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
            radio.addEventListener('change', handleRadioChange);
        });
    });
});


// Changing Von to ab
 document.addEventListener('DOMContentLoaded', function() {
    // Select all elements that have both classes: .price-item--sale and .price-item--last
    var priceElements = document.querySelectorAll('.price-item--sale.price-item--last');
    
    priceElements.forEach(function(el) {
      // Get the current text (e.g., "Von €80,00")
      var currentText = el.textContent.trim();
      
      // Replace "Von" with "ab" (or whatever text you prefer)
      // This leaves the numeric part (the price) untouched
      var newText = currentText.replace('Von', 'ab');
      
      // Update the element’s text
      el.textContent = newText;
    });
  });

//faq
// Select all FAQ items
const faqItems = document.querySelectorAll('.faq-acc-item');

// Add click event listener to each title
faqItems.forEach(item => {

    item.addEventListener('click', () => {
        // Check if this item is already active
        const isActive = item.classList.contains('active');

        // Close all other items
        faqItems.forEach(otherItem => otherItem.classList.remove('active'));

        // Toggle the current item's active state
        if (!isActive) {
            item.classList.add('active');
        }
    });
});


// Landing page 
 
document.addEventListener("DOMContentLoaded", function() {
  // 1) Determine the user's current language (from <html lang="..."> in this example)
  const currentLang = document.documentElement.lang || "en"; // default to 'en' if missing

  // 2) Define your video sources by language (as shown above)
  const videoLinks = {
    en: {
      video1: "https://cdn.shopify.com/videos/c/o/v/733e2af53587443ea5a31e4faecd1f49.mp4",
      video2: "https://cdn.shopify.com/videos/c/o/v/74b6736ff3bc47fd8f0adacb7ca77394.mp4"
    },
    de: {
      video1: "https://cdn.shopify.com/videos/c/o/v/21c605da556f465bad1622cf8c2d78d3.mp4",
      video2: "https://cdn.shopify.com/videos/c/o/v/fed8a20d42514bcaa6cd20c1f56788ec.mp4"
    },
    fr: {
      video1: "https://cdn.shopify.com/videos/c/o/v/9f662f8d957b496fab816ab1ece6d48f.mp4",
      video2: "https://cdn.shopify.com/videos/c/o/v/e393ad5501994368820dc7488f669636.mp4"
    }
  };

  // 3) Get the correct set of URLs for the currentLang
  const { video1, video2 } = videoLinks[currentLang] || videoLinks.en;

    // 4) Update video1
  const uspVideo1 = document.querySelector('#usp-video1');
  if (!uspVideo1) {
    console.warn('Video element with ID "usp-video1" not found.');
    return;
  }

  // 5) Update video1
  const video1Source = document.querySelector('#usp-video1 source');
  video1Source.setAttribute('src', video1);
  document.querySelector('#usp-video1').load(); // reload the video with the new source

  // 6) Update video2
  const video2Source = document.querySelector('#usp-video2 source');
  video2Source.setAttribute('src', video2);
  document.querySelector('#usp-video2').load(); // reload the video with the new source
});
 



